export function getConfig (config) {
  /* Fallback configuration if no config param is sent and SSR is true.
   * Not sure if these actually is used anytime, probably not (maybe epi6?).
   * Make sure though that these are production urls, same as values-prod.yaml */
  let environmentConfiguration = {
    "cloudinaryBaseUrl": "https://assets.icanet.se",
    "baseUrl": "https://www.ica.se",
    "wso2External": "https://apimgw-pub.ica.se/sverige/digx",
    "recipeExperienceApiBaseUrl": "https://apimgw-pub.ica.se/sverige/digx/ica-recipe-experience/v1",
    "customerStoresApiBaseUrl": "https://apimgw-pub.ica.se/sverige/digx/customerstores/v1",
    "customerDataApiBaseUrl": "https://apimgw-pub.ica.se/sverige/digx/customer-data/v1/customers/me",
    "cookieSubDomain": ".ica.se",
    "loginEndpointUrl": "http://login-test.ica.ia-hc.net/logga-in/sso/",
    "onlineScriptSrc": ""
  }

  if (SSR_MODE && config) {
    environmentConfiguration = config
  } else if (window && window._vueContext && window._vueContext.envConfig) {
    environmentConfiguration = window._vueContext.envConfig
  }

  return environmentConfiguration
}
